import styled from 'styled-components';
import { facebookBlue } from '../colors';
import { default as FacebookIcon } from './FacebookIconSolid';

export const FacebookIconBlue = styled(FacebookIcon)`
  fill: ${facebookBlue};
`;
